<template>
  <div class="full-container">
    <div
        style="width: 100%;float: left;height: 50px;line-height: 50px;font-size: 0.9rem; text-align: left;opacity: 0.9;">
      商品管理
    </div>
    <div style="width:100%;height:auto;float:left;border-radius: 15px;background-color: white;padding-bottom:40px;">

      <div style="width:100%;float:left;margin-top: 10px;">
        <!-- 查询按钮区 -->
        <div style="width: 100%;height: 60px;float: left;line-height: 60px;padding-left: 15px">
          <!-- 左边查询区 -->
          <div style="width: auto;float: left;margin-right: 20px">
            <label style="float: left;font-size: 0.9rem;opacity: 0.9;">商户名称：</label>
            <el-input v-model="selectForm.companyNameKeyWords" clearable placeholder="模糊查询" prefix-icon="el-icon-search"
                      size="mini" style="width: 200px;float: left;"></el-input>
          </div>
          <div style="width: auto;float: left;margin-right: 20px">
            <label style="float: left;font-size: 0.9rem;opacity: 0.9;">商品名称：</label>
            <el-input v-model="selectForm.name" clearable placeholder="模糊查询" prefix-icon="el-icon-search"
                      size="mini" style="width: 200px;float: left;"></el-input>
          </div>
          <div style="width: auto;float: left;margin-right: 20px">
            <label style="float: left;font-size: 0.9rem;opacity: 0.9;">是否上架：</label>
            <el-select v-model="selectForm.isShelf" clearable filterable size="mini" style="width:100px;float: left;">
              <el-option v-for="item in alexBoolList" :key="item.value" :label="item.zhName" :value="item.value">
              </el-option>
            </el-select>
          </div>
          <div style="width: auto;float: left;margin-right: 20px">
            <el-button size="mini" style="background-color: #25AD7F;border:none;" type="primary"
                       @click="pageAllProduct(true)">搜索
            </el-button>
            <el-button size="mini" style="background-color: #25AD7F1A;border:1px solid #25AD7F;color:#25AD7F"
                       type="primary" @click="selectReset()">重置
            </el-button>
          </div>
          <!-- 右边按钮 -->
          <div style="width: auto;float: right;margin-right: 20px">


            <el-button size="mini" style="background-color: #25AD7F1A;border:1px solid #25AD7F;color:#25AD7F"
                       type="primary" @click="exportTable">
              <a-icon type="plus-circle"/>
              批量导出
            </el-button>

            <a-popconfirm cancel-text="取消" ok-text="确定" title="是否删除?(敏感操作!)"
                          @confirm="deleteProductBatch()">
              <el-button size="mini" style="background-color: #e32e2e1a;color:#e32e2e;border:1px solid #e32e2e;"
                         type="primary">
                <a-icon type="minus-circle"/>
                批量删除
              </el-button>
            </a-popconfirm>
          </div>
        </div>

        <!-- 表单内容 -->
        <div style="width:100%;float:left;padding: 15px;">
          <el-table v-loading="tableLoading" :data="tableData" align="center" height="600"
                    size="mini"
                    style="color: #555;" @selection-change="handleSelectionChange">
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column align="center" label="商户" min-width="20%">
              <template slot-scope="scope">
                {{
                  scope.row.merchantVO && scope.row.merchantVO.merchantDetailVO ? scope.row.merchantVO.merchantDetailVO.companyName : ''
                }}
              </template>
            </el-table-column>
            <el-table-column align="center" label="名称" min-width="20%" prop="name"></el-table-column>
            <el-table-column align="center" label="描述" min-width="20%" prop="title"></el-table-column>
            <el-table-column align="center" label="商品主图" min-width="20%">
              <template slot-scope="scope">
                <el-image v-if="scope.row.mainImageGuid"
                          :preview-src-list="['/admin/web/file/downloadFile?id='+scope.row.mainImageGuid]"
                          :src="'/admin/web/file/downloadFile?id='+scope.row.mainImageGuid"
                          style="width: 100px; height: 100px"
                          title="点击放大">
                </el-image>
              </template>
            </el-table-column>
            <el-table-column align="center" label="一级类型" min-width="20%" prop="goodsTypeStr"></el-table-column>
            <el-table-column align="center" label="二级类型" min-width="20%">
              <template slot-scope="scope">
                {{ scope.row.productTypeStr ? scope.row.productTypeStr : '' }}
                {{ scope.row.workflowTypeStr ? scope.row.workflowTypeStr : '' }}
              </template>

            </el-table-column>
            <el-table-column align="center" label="单位" min-width="20%" prop="unit"></el-table-column>
            <el-table-column align="center" label="价格(￥)" min-width="20%" prop="price"></el-table-column>
            <el-table-column align="center" label="折后价(￥)" min-width="20%" prop="payPrice"></el-table-column>
            <el-table-column align="center" label="库存" min-width="20%" prop="inventory"></el-table-column>
            <el-table-column label="是否上架" min-width="20%">
              <template slot-scope="scope">
                {{ scope.row.isShelf == '1' ? '上架' : '下架' }}
              </template>
            </el-table-column>
            <el-table-column label="显示在首页" min-width="20%">
              <template slot-scope="scope">
                <el-switch v-model="scope.row.isShowIndex"
                           active-color="#13ce66"
                           active-value="1" inactive-color="#ff4949" inactive-value="0"
                           @change="updateIsShowIndex(scope.row.id,scope.row.isShowIndex)">
                </el-switch>
              </template>
            </el-table-column>

            <el-table-column align="center" label="创建时间" min-width="20%">
              <template slot-scope="scope">
                {{ parseDate(scope.row.createDate ? scope.row.createDate : "") }}
              </template>
            </el-table-column>
            <el-table-column align="center" label="操作" min-width="20%">
              <template slot-scope="scope">
                <span style="font-size:0.9rem;color:#25AD7F;cursor: pointer;"
                      @click="detailShow(scope.row)">详情</span>
                <a-popconfirm cancel-text="取消" ok-text="确定" title="是否删除?(敏感操作!)"
                              @confirm="deleteProduct(scope.row)">
                  <span style="margin:0px 5px">|</span>
                  <span style="font-size:0.9rem;color:#e32e2e;cursor: pointer;">删除</span>
                </a-popconfirm>
              </template>
            </el-table-column>
          </el-table>
          <div style="width: 100%;float: right;margin-top: 10px;text-align: right;">
            <el-pagination
                :current-page="selectForm.pageIndex"
                :page-size="selectForm.pageSize"
                :total="selectForm.total"
                layout="total,prev, pager, next"
                @current-change="handleCurrentChange">
            </el-pagination>
          </div>
        </div>
      </div>
    </div>


    <!-- 详情 -->
    <el-dialog :before-close="detailCancel" :visible.sync="detailDialog" title="商品详情" width="40%">
      <div style="width: 100%;float: left">
        <div
            v-if="detailInfo"
            style="width: 100%;float: left;border-bottom: 1px solid #80808054;padding-bottom: 15px;margin-bottom: 20px;">

          <el-descriptions :column=2 title="商户">
            <el-descriptions-item label="商户名称"> {{detailInfo.merchantVO && detailInfo.merchantVO.merchantDetailVO ? detailInfo.merchantVO.merchantDetailVO.companyName : ''}}
            </el-descriptions-item>

          </el-descriptions>

          <el-descriptions :column=2 :title="detailInfo.name?detailInfo.name:''">
            <el-descriptions-item label="描述">{{ detailInfo.title ? detailInfo.title : "" }}
            </el-descriptions-item>
            <el-descriptions-item label="一级类型">{{ detailInfo.goodsTypeStr ? detailInfo.goodsTypeStr : '' }}
            </el-descriptions-item>
            <el-descriptions-item label="二级类型">{{
                detailInfo.productTypeStr ? detailInfo.productTypeStr : ''
              }}{{ detailInfo.workflowTypeStr ? detailInfo.workflowTypeStr : '' }}
            </el-descriptions-item>
            <el-descriptions-item label="单位">{{ detailInfo.unit ? detailInfo.unit : "" }}
            </el-descriptions-item>
            <el-descriptions-item label="价格">{{ detailInfo.price ? detailInfo.price : "0" }}元
            </el-descriptions-item>
            <el-descriptions-item label="折后价">{{ detailInfo.payPrice ? detailInfo.payPrice : "0" }}元
            </el-descriptions-item>
            <el-descriptions-item label="库存">{{ detailInfo.inventory ? detailInfo.inventory : "0" }}
            </el-descriptions-item>
            <el-descriptions-item label="特色">{{ detailInfo.feature ? detailInfo.feature : "" }}
            </el-descriptions-item>
            <el-descriptions-item label="商品性能">{{ detailInfo.context ? detailInfo.context : "" }}
            </el-descriptions-item>
            <el-descriptions-item :span="2" label="创建时间">
              {{
                parseDate(detailInfo.createDate ? detailInfo.createDate : "")
              }}
            </el-descriptions-item>
            <el-descriptions-item :span="2" label="缩略照片">
              <el-image v-if="detailInfo.mainImageGuid"
                        :preview-src-list="['/admin/web/file/downloadFile?id='+detailInfo.mainImageGuid]"
                        :src="'/admin/web/file/downloadFile?id='+detailInfo.mainImageGuid"
                        style="width: 100px; height: 100px"
                        title="点击放大">
              </el-image>
            </el-descriptions-item>
            <el-descriptions-item :span="2" label="详细照片">
              <div v-for="guid in detailInfo.detailImageGuid" v-if="detailInfo.detailImageGuid"
                   style="width: 100%;float: left;">
                <el-image :preview-src-list="['/admin/web/file/downloadFile?id='+guid]"
                          :src="'/admin/web/file/downloadFile?id='+guid"
                          style="width: 100px; height: auto"
                          title="点击放大">
                </el-image>
                <br/>
              </div>
            </el-descriptions-item>
          </el-descriptions>
        </div>

      </div>
      <div class="dialog-footer">
        <el-button class="dialog-footer-cancel" @click="detailCancel">关闭</el-button>
      </div>
    </el-dialog>


  </div>
</template>

<script>


import * as XLSX from "xlsx";
import {saveAs} from "file-saver";
import {getAlexBoolListApi} from "@/router/api/common/data-api";
import {deleteProductApi, pageAllProductApi, updateIsShelfApi,updateIsShowIndexApi} from "@/router/api/product/product-api";

export default {
  name: "ProductIndex",
  data() {
    return {
      alexBoolList: [],


      // 查询
      tableData: [],
      selectForm: {
        companyNameKeyWords: null,
        name: null,
        isShelf: null,
        pageIndex: 1,
        pageSize: 10,
        total: 0
      },
      selectTableRow: [],
      tableLoading: false,


      //  详情
      detailDialog: false,
      detailInfo: null,


    };
  },

  mounted() {

    getAlexBoolListApi({}, res => {
      if (res.status == "200") {
        if (res.data && res.data.status && res.data.msg) {
          if ("1" == res.data.status) {
            this.alexBoolList = res.data.resultSetData;
          } else {
            this.showMessage(res.data.msg, "error");
          }
        } else {
          this.showMessage("未知请求出错", "error");
        }
      } else {
        this.showMessage("未知请求出错！", "error");
      }
    });
    this.pageAllProduct();
  },

  methods: {

    // 查询 begin
    selectReset() {
      this.selectForm = {
        companyNameKeyWords: null,
        name: null,
        isShelf: null,
        pageIndex: 1,
        pageSize: 10,
        total: 0
      };
      this.pageAllProduct(true);
    },

    handleCurrentChange(e) {
      this.selectForm.pageIndex = e;
      this.pageAllProduct(true);
    },

    handleSelectionChange(val) {
      this.selectTableRow = val;
    },

    pageAllProduct(showMessage) {
      this.tableLoading = true;
      pageAllProductApi(this.selectForm, res => {
        if (res.status == "200") {
          if (res.data && res.data.status && res.data.msg) {
            if ("1" == res.data.status) {
              if (showMessage) {
                this.showMessage(res.data.msg, "success");
              }
              this.tableData = res.data.resultSetData.list;
              this.selectForm.pageIndex = res.data.resultSetData.pageNum;
              this.selectForm.pageSize = res.data.resultSetData.pageSize;
              this.selectForm.total = res.data.resultSetData.total;
            } else {
              this.showMessage(res.data.msg, "error");
            }
          } else {
            this.showMessage("未知请求出错", "error");
          }
        } else {
          this.showMessage("未知请求出错！", "error");
        }
      }, res => {
        this.tableLoading = false;
      });
    },

    exportTable() {
      if (!this.selectTableRow || this.selectTableRow.length == 0) {
        this.showMessage("请勾选需要导出的数据", "warning");
        return false;
      }

      const data = [
        [
          "商户",
          "名称",
          "描述",
          "一级类型",
          "单位",
          "价格",
          "折后价",
          "库存",
          "特色",
          "商品性能",
          "是否上架",
        ]
      ]

      //添加数据

      for (let i = 0; i < this.selectTableRow.length; i++) {
        let row = this.selectTableRow[i];
        if (row) {
          let cell1 = row.merchantVO && row.merchantVO.merchantDetailVO ? row.merchantVO.merchantDetailVO.companyName : ''
          let cell2 = row.name ? row.name : "";
          let cell3 = row.title ? row.title : "";
          let cell4 = row.goodsTypeStr ? row.goodsTypeStr : "";
          let cell5 = row.unit ? row.unit : "";
          let cell6 = row.price ? row.price : "";
          let cell7 = row.payPrice ? row.payPrice : "";
          let cell8 = row.inventory ? row.inventory : "";
          let cell9 = row.feature ? row.feature : "";
          let cell10 = row.context ? row.context : "";
          let cell11 = row.isShelf &&row.isShelf==1? "上架" : "下架";
          data.push([cell1, cell2, cell3, cell4, cell5, cell6,cell7,cell8,cell9,cell10,cell11]);
        }
      }
      // 将数据转换为工作表
      const worksheet = XLSX.utils.aoa_to_sheet(data);

      // 创建工作簿并添加工作表
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

      // 生成Excel文件
      const excelBuffer = XLSX.write(workbook, {bookType: "xlsx", type: "array"});

      // 使用blob和FileReader创建一个Blob URL
      const dataBlob = new Blob([excelBuffer], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8"});
      const blobUrl = window.URL.createObjectURL(dataBlob);

      // 使用saveAs下载文件
      saveAs(dataBlob, "商户用户-" + new Date().toLocaleString() + ".xlsx");

      // 清理
      window.URL.revokeObjectURL(blobUrl);
    },

    // 查询 end


    // 详情 begin
    detailShow(data) {
      this.detailInfo = data;
      this.detailDialog = true;
    },

    detailCancel() {
      this.detailDialog = false;
      this.detailInfo = null;
    },
    // 详情 end


    // 删除 begin
    deleteProduct(item) {
      if (!item) {
        this.showMessage("请选择需要删除的商品", "warning");
        return false;
      }
      let params = [
        {
          "id": item.id
        }
      ];
      deleteProductApi(params, res => {
        //状态200
        if (res.status == "200") {
          if (res.data && res.data.status && res.data.msg) {
            if ("1" == res.data.status) {
              this.showMessage(res.data.msg, "success");
              this.pageAllProduct();
            } else {
              this.showMessage(res.data.msg, "error");
            }
          } else {
            this.showMessage("未知请求出错", "error");
          }
        } else {
          this.showMessage("未知请求出错！", "error");
        }
      });
    },

    deleteProductBatch() {
      if (!this.selectTableRow || this.selectTableRow.length == 0) {
        this.showMessage("请勾选需要需要删除的商品", "warning");
        return false;
      }

      let params = [];
      for (let i = 0; i < this.selectTableRow.length; i++) {
        let row = this.selectTableRow[i];
        if (row) {
          params.push({
            "id": row.id
          });
        }
      }

      deleteProductApi(params, res => {
        //状态200
        if (res.status == "200") {
          if (res.data && res.data.status && res.data.msg) {
            if ("1" == res.data.status) {
              this.showMessage(res.data.msg, "success");
              this.pageAllProduct();
            } else {
              this.showMessage(res.data.msg, "error");
            }
          } else {
            this.showMessage("未知请求出错", "error");
          }
        } else {
          this.showMessage("未知请求出错！", "error");
        }
      });
    },

    // 删除 end

    // 修改 begin
    updateIsShowIndex(id, isShowIndex) {
      let params = {
        "id": id,
        "isShowIndex": isShowIndex
      };
      updateIsShowIndexApi(params, res => {
        if (res.status == "200") {
          if (res.data && res.data.status && res.data.msg) {
            if ("1" == res.data.status) {
              this.showMessage(res.data.msg, "success");
            } else {
              this.showMessage(res.data.msg, "error");
            }
          } else {
            this.showMessage("未知请求出错", "error");
          }
        } else {
          this.showMessage("未知请求出错！", "error");
        }
      });
    },

    // 工具
    parseDate(date) {
      if (date) {
        return new Date(date).toLocaleString();
      }
      return "";
    }
  }
}
;

</script>


<style scoped>

/deep/ .el-card__body, .el-main {
  float: left;
  width: 100%;
}

/*  通用 */
.dialog-footer {
  width: 100%;
  float: left;
  text-align: left;
}

.dialog-footer-submit {
  background-color: #25AD7F;
  color: white;
  width: 130px;
  border-radius: 50px;
  letter-spacing: 3px;
  text-align: center;
  font-weight: 100;
}

.dialog-footer-submit:hover {
  background-color: #25AD7F;
  color: white;
  width: 130px;
  border-radius: 50px;
  letter-spacing: 3px;
  text-align: center;
  font-weight: 100;
}

.dialog-footer-cancel {
  background-color: white;
  border: 1px solid #8080805c;
  color: #8080805c;
  width: 130px;
  border-radius: 50px;
  letter-spacing: 3px;
  text-align: center;
  font-weight: 100;
}

.dialog-footer-cancel:hover {
  background-color: white;
  border: 1px solid #8080805c;
  color: #8080805c;
  width: 130px;
  border-radius: 50px;
  letter-spacing: 3px;
  text-align: center;
  font-weight: 100;
}

/* 树形菜单 */

/deep/ .el-tree-node__content {
  height: 35px;
  line-height: 35px;
}

/* 表格 */

/deep/ .el-table th.el-table__cell {
  background-color: #F8F8F8;
}

/deep/ .el-table th.el-table__cell > .cell {
  color: #554 !important;
  font-weight: 600;
  font-size: 1.05rem;
}


/* 模态框 */

/deep/ .el-dialog__title {
  font-weight: 600;
}

/deep/ .el-dialog__header {
  text-align: left;
  border-bottom: 1px solid darkgray;
}

/deep/ .el-dialog__body {
  width: 100%;
  float: left;
  background-color: white;
}

/deep/ .el-upload-dragger {
  height: auto;
}

/deep/ .el-form-item__content {
  text-align: left;
}


/* 纯数字 */
/deep/ .numberInput input::-webkit-outer-spin-button,
/deep/ .numberInput input::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
}

/deep/ .numberInput input[type="number"] {
  -moz-appearance: textfield;
}


</style>
